import toastMessage from "../../utils/toastMessage";
import language from "../../language";
import formatDropdownData from "../../utils/formatDropdownData";
import axios from "axios";
import { getStorage } from "../../utils/storage";
import api from "../../utils/api";

export const fetchAccountType = async (lng = "english", params) => {
  const { listType } = params || {};
  const { accessToken, sub } = await getStorage();
  let headers = {
    "Content-Type": "application/json;charset=UTF-8",
  };

  try {
    if (accessToken) {
      headers.Authorization = "Bearer " + accessToken;
    }

    const options = {
      method: "GET",
      url: `${api("core")}/account/types`,
      data: null, //force axios send headers content type
      headers,
    };

    const data = await axios(options);

    if (listType === "dropdown") {
      return formatDropdownData(data.data, "type", "id");
    }

    return data.data;
  } catch (error) {
    toastMessage("error", language[lng].unable_to_fetch_account_type);
  }
};
